import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AITripDataService } from '../ai-trip-data.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
// import { UserLayoutService } from 'projects/admin/src/app/layouts/user-layout/user-layout.service';
import { UserLayoutService } from '../../../../layouts/user-layout/user-layout.service';
import { CommonService } from '../../../../shared/common.service';
const countryData = require('../../../country-code.json');
declare var $: any;

interface MarkerData {
  marker: google.maps.Marker;
  infoWindow: google.maps.InfoWindow;
  lat: number;
  lng: number;
  title: string;
}
@Component({
  selector: 'app-ai-itinerary',
  templateUrl: './ai-itinerary.component.html',
  styleUrls: ['./ai-itinerary.component.css']
})
export class AiItineraryComponent implements OnInit {
  tripDetails: any;
  tripItinerary: any;
  tripInfo: any;

  map: google.maps.Map | null = null;
  markers: MarkerData[] = [];
  openInfoWindow: google.maps.InfoWindow | null = null;

  loadingInterests = false;

  bookingFormSubmitted: boolean = false;
  contactDetailsForm: FormGroup;
  packages: any = [];
  countryData = countryData;

  constructor(private router: Router, private fb: FormBuilder,
    private aitripDataService: AITripDataService,
    public userLayoutService: UserLayoutService, private sanitizer: DomSanitizer,
    public commonService: CommonService, private meta: Meta, private title: Title
  ) { }

  sanitizeImageUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
    this.tripDetails = this.aitripDataService.getTripData();
    // this.getitinery()
    if (!this.tripDetails) {
      this.router.navigate(['ai-trip']);
      //this.onSubmit()
    }
    else {
      this.initRecommendedCitiesSlick()
      this.defaultContactDetailsForm()
      this.generateItinerary()
    }
  }
  metaTagAdd() {
    this.title.setTitle('AI Powered Trip Planner | My Yatra 360');

    this.meta.updateTag({
      name: 'description',
      content: 'Let our smart AI assistant craft your perfect travel itinerary — from hidden gems to top attractions. Plan your dream trip effortlessly with My Yatra 360.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'AI Trip Planner Pilgrimage Tours'
    });
  }
  getitinery() {
    let jsonString = `{
      "tripInfo" : { 
        "description":"Family trip to Haridwar, Uttarakhand, India",
        "dates":"09 Jul, 2025 - 12 Jul, 2025"
      },
      "itinerary": [
        {
          "day": "2025-07-09",
          "activities": [
            "Check-in at hotel",
            "Evening visit to Har Ki Pauri Ghat for a spiritual retreat"
          ],
          "hotels":{
            "name": "Hotel Radisson Blu Haridwar",
            "address": "Pant Dweep, Haridwar, Uttarakhand 249403, India",
            "latitude": 29.9457,
            "longitude": 78.1642,
            "description": "Luxurious hotel with top-notch amenities",
            "star_rating":"4.5",
            "checkin": "9 Jul" ,
            "checkout": "12 Jul",
            "dates" : "Wed, 9 - Sat, 12, Jul 2025"
          }
        },
        {
          "day": "2025-07-10",
          "activities": [
            "Morning Yoga & Meditation session at Shanti Kunj Ashram",
            "Visit Rajaji National Park for Wildlife Safari",
            "Try local cuisine at Chotiwala Restaurant"
          ],  
          "hotels":{
            "name": "Hotel Radisson Blu Haridwar",
            "address": "Pant Dweep, Haridwar, Uttarakhand 249403, India",
            "latitude": 29.9457,
            "longitude": 78.1642,
            "description": "Luxurious hotel with top-notch amenities",
            "star_rating":"4.5",
            "checkin": "9 Jul" ,
            "checkout": "12 Jul",
            "dates" : "Wed, 9 - Sat, 12, Jul 2025"
          }
        },
        {
          "day": "2025-07-11",
          "activities": [
            "River rafting in the Ganges",
            "Heritage Walk through Haridwar",
            "Shopping for artisanal crafts at Bara Bazaar"
          ],  
          "hotels":{
            "name": "Hotel Radisson Blu Haridwar",
            "address": "Pant Dweep, Haridwar, Uttarakhand 249403, India",
            "latitude": 29.9457,
            "longitude": 78.1642,
            "description": "Luxurious hotel with top-notch amenities",
            "star_rating":"4.5",
            "checkin": "9 Jul" ,
            "checkout": "12 Jul",
            "dates" : "Wed, 9 - Sat, 12, Jul 2025"
          }
        },
        {
          "day": "2025-07-12",
          "activities": [
            "Mountain Hiking in the Himalayan ranges",
            "Check-out from hotel"
          ],  
          "hotels":{
            "name": "Hotel Radisson Blu Haridwar",
            "address": "Pant Dweep, Haridwar, Uttarakhand 249403, India",
            "latitude": 29.9457,
            "longitude": 78.1642,
            "description": "Luxurious hotel with top-notch amenities",
            "star_rating":"4.5",
            "checkin": "9 Jul" ,
            "checkout": "12 Jul",
            "dates" : "Wed, 9 - Sat, 12, Jul 2025"
          }
        }
      ]
    }`
    let parsed: any = JSON.parse(jsonString);
    this.tripItinerary = parsed.itinerary;
    this.tripInfo = parsed.tripInfo;
    this.clearMarkers();

    this.loadingInterests = false; // Hide loader

    setTimeout(async () => {
      this.initMap();

      if (this.tripDetails.destination) {
        const photoUrl = await this.fetchDestinationPhoto(this.tripDetails.destination);
        const isValid = await this.checkImage(photoUrl);
        this.tripInfo.destinationImage = isValid ? photoUrl : 'assets/images/ai/ai_itinerary_hero.png';
      }

      for (const day of this.tripItinerary) {
        // ✅ Add hotel marker with photo
        if (day.hotels && day.hotels.latitude && day.hotels.longitude) {
          const hotelPhoto = await this.fetchPlacePhoto(day.hotels.name, day.hotels.address);

          // Attach photo to hotel object so it can be shown in the UI too
          day.hotels.imageUrl = this.sanitizeImageUrl(hotelPhoto);;

          this.addMarker(
            day.hotels.latitude,
            day.hotels.longitude,
            day.hotels.name,
            hotelPhoto
          );
        }

        // ✅ Add activity markers (geocode + no image)
        for (const activityName of day.activities) {
          this.geocodeActivityAndAdd(activityName);
        }
      }
    }, 500);
    this.getDivineDestinationSearch()

  }
  generateItinerary() {
    this.loadingInterests = true; // Show loader
    const prompt = `
                Generate a detailed travel itinerary for a ${this.tripDetails.tripType} trip to  ${this.tripDetails.destination} 
                from ${this.tripDetails.startDate} to ${this.tripDetails.endDate}.
                The user is interested in: ${this.tripDetails.interests}
                The itinerary should include:

                Output the data in this exact JSON structure. don't give any other text only strict with this format:
                    {
                      "tripInfo" : { 
                             "description":"7 days trip in Varanasi, Uttar Pradesh, India",
                             "dates":"25 Jun, 2025 - 01 Jul, 2025",
                             "place":"Varanasi, Uttar Pradesh, India",
                             "startDate":"2025-06-25",
                             "endDate":"2025-07-01",
                        },
                        "itinerary": [
                        {
                          "day": "2025-07-01",
                          "activities": [
                            "Check-in at hotel",
                            "Evening visit to Har Ki Pauri Ghat"
                          ],
                          "hotels":{
                              "name": "Hotel Name",
                              "address": "Hotel address",
                              "latitude": 00.0000,
                              "longitude": 00.0000,
                              "description": "Short description of hotel",
                              "star_rating":"star rating of hotel in number",
                              "checkin": "9 Aug" ,
                              "checkout": "12 Aug",
                              "dates" : "Thu, 8 - 12, Aug 2024"
                            }
                        },
                        {
                          "day": "2025-07-02",
                          "activities": [
                            "Visit Rajaji National Park for Wildlife Safari",
                            "Try local cuisine at Mohan Ji Puri Wale"
                            ],  
                            "hotels":{
                                "name": "Hotel Name",
                                "address": "Hotel address",
                                "latitude": 00.0000,
                                "longitude": 00.0000,
                                "description": "Short description of hotel",
                                "star_rating":"star rating of hotel in number"
                                "checkin": "9 Aug" ,
                                "checkout": "12 Aug",
                                "dates" : "Thu, 8 - 12, Aug 2024"
                              }
                        }
                        // Repeat till end date
                      ]`;
    this.aitripDataService.generateTripPlan(prompt).subscribe({
      next: async (response: any) => {
        const content = response.choices[0].message.content;

        // Find the first `{` and last `}` to extract the JSON substring
        const jsonStart = content.indexOf('{');
        const jsonEnd = content.lastIndexOf('}');
        const jsonString = content.substring(jsonStart, jsonEnd + 1);

        try {
          let parsed: any = JSON.parse(jsonString);
          this.tripItinerary = parsed.itinerary;
          this.tripInfo = parsed.tripInfo;
          this.clearMarkers();

          this.loadingInterests = false; // Hide loader

          setTimeout(async () => {
            this.initMap();

            if (this.tripDetails.destination) {
              const photoUrl = await this.fetchDestinationPhoto(this.tripDetails.destination);
              const isValid = await this.checkImage(photoUrl);
              this.tripInfo.destinationImage = isValid ? photoUrl : 'assets/images/ai/ai_itinerary_hero.png';
            }

            for (const day of this.tripItinerary) {
              // ✅ Add hotel marker with photo
              if (day.hotels && day.hotels.latitude && day.hotels.longitude) {
                const hotelPhoto = await this.fetchPlacePhoto(day.hotels.name, day.hotels.address);

                // Attach photo to hotel object so it can be shown in the UI too
                day.hotels.imageUrl = this.sanitizeImageUrl(hotelPhoto);;

                this.addMarker(
                  day.hotels.latitude,
                  day.hotels.longitude,
                  day.hotels.name,
                  hotelPhoto
                );
              }

              // ✅ Add activity markers (geocode + no image)
              for (const activityName of day.activities) {
                this.geocodeActivityAndAdd(activityName);
              }
            }
          }, 500);
          this.getDivineDestinationSearch()
        } catch (error) {
          console.error("Failed to parse AI itinerary response", error);
          this.loadingInterests = false; // Hide loader
          this.commonService.notifier.notify('error', "An Error Occured While generate itinerary");
          this.router.navigate(['ai-trip']);
        }
      },
      error: (err) => {
        console.error('OpenAI API Error:', err);
        this.loadingInterests = false; // Hide loader
        this.commonService.notifier.notify('error', "An Error Occured While generate itinerary");
        this.router.navigate(['ai-trip']);
      },
    });
  }
  //#region Map
  initMap(mapElementId: string = 'map') {
    const mapElement = document.getElementById(mapElementId);
    if (!mapElement) {
      console.error('Map element not found');
      return;
    }

    this.map = new google.maps.Map(mapElement, {
      zoom: 12,
      center: { lat: 23.0225, lng: 72.5714 } // India center fallback
    });

    this.clearMarkers();
  }
  clearMarkers() {
    this.markers = this.markers || [];
    this.markers.forEach(m => m.marker.setMap(null)); // ✅ Access inner .marker
    this.markers = [];
  }

  addMarker(lat: number, lng: number, title: string, imageUrl?: string) {
    const marker = new google.maps.Marker({
      position: { lat, lng },
      map: this.map,
      title,
    });

    const infoContent = `
    <div style="max-width: 200px">
      <strong>${title}</strong><br/>
      ${imageUrl ? `<img src="${imageUrl}" width="100%">` : ''}
    </div>
  `;

    const infoWindow = new google.maps.InfoWindow({
      content: infoContent
    });

    marker.addListener('click', () => infoWindow.open(this.map, marker));
    this.markers.push({ marker, infoWindow, lat, lng, title });
  }
  //#endregion

  //#region Add Images  & GeoCode let/lat
  async fetchPlacePhoto(placeName: string, locationHint: string = ''): Promise<string | null> {
    return new Promise((resolve) => {
      const service = new google.maps.places.PlacesService(this.map);

      const request: google.maps.places.TextSearchRequest = {
        query: `${placeName} ${locationHint}`
      };

      service.textSearch(request, (results, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          results?.[0]?.photos?.length
        ) {
          const photoUrl = results[0].photos[0].getUrl({ maxWidth: 600 });
          resolve(photoUrl);
        } else {
          resolve(null);
        }
      });
    });
  }
  async fetchDestinationPhoto(destination: string): Promise<string | null> {
    return new Promise((resolve) => {
      const service = new google.maps.places.PlacesService(this.map);

      const request: google.maps.places.TextSearchRequest = {
        query: destination
      };

      service.textSearch(request, (results, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          results?.[0]?.photos?.length
        ) {
          const photoUrl = results[0].photos[0].getUrl({ maxWidth: 1600 });// ✅ CORRECT
          resolve(photoUrl);
        } else {
          resolve(null);
        }
      });
    });
  }

  geocodeActivityAndAdd(activityName: string) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: activityName + ', ' + this.tripDetails.destination }, async (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        const photoUrl = await this.fetchPlacePhoto(activityName, this.tripDetails.destination);
        const isValid = await this.checkImage(photoUrl);
        const imageUrl = isValid ? photoUrl : '';

        this.addMarker(location.lat(), location.lng(), activityName, imageUrl);
        this.map.setCenter(location);
      } else {
        console.warn('Could not geocode activity:', activityName);
      }
    });
  }
  onImageError(event: any, type: number) {
    event.target.src = "assets/images/packageDetailsImages/hotel.png";
  }
  checkImage(url: string): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  }
  //#endregion

  //#region zoom map
  zoomToMarker(title: string) {
    const match = this.markers.find(m => m.title === title);
    if (match) {
      this.map.panTo({ lat: match.lat, lng: match.lng });
      this.map.setZoom(17);

      match.marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => match.marker.setAnimation(null), 1400);

      match.infoWindow.open(this.map, match.marker); // ✅ Show popup
    }
  }

  resetMapZoom() {
    this.map.setZoom(12);
    this.markers.forEach(m => {
      m.infoWindow.close();
      m.marker.setAnimation(null);
    });
  }
  //#endregion

  getDivineDestinationSearch() {
    let paramsObj = {
      City: this.tripDetails.destination,
      Days: '',
      PilgrimPathway: '',
      FestivalId: '',
      GodList: '',
      PageNumber: 1,
      PageSize: 10
    }

    this.userLayoutService
      .getDivineDestinationSearch(paramsObj).subscribe(
        (res: any) => {
          if (res.code === 1) {
            this.packages = res.data.packages.map((pkg: any) => {
              const match = pkg.numberOfDaysAndNight?.match(/(\d+)\s*Days\s*(\d+)\s*Nights/i);
              return {
                ...pkg,
                totalDay: match ? parseInt(match[1], 10) : null,
                totalNight: match ? parseInt(match[2], 10) : null,
              };
            });
            setTimeout(() => {
              this.initRecommendedCitiesSlick();
            }, 100);
          } else {
            this.packages = [];
          }
        },
        (error) => {
          console.error("Error fetching packages:", error);
          this.packages = [];
        }
      );
  }
  //#region Send Enquiry
  initRecommendedCitiesSlick(): void {
    if ($('.bestrecommendedSlider').hasClass('slick-initialized')) {
      $('.bestrecommendedSlider').slick('unslick'); // Destroy existing instance
    }

    $('.bestrecommendedSlider').slick({
      prevArrow: $('.best-prev'),
      nextArrow: $('.best-next'),
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      centerPadding: '20px',
      autoplay: true,
      cssEase: "linear",
      pushOnHover: true,
      autoplaySpeed: 2000,

      responsive: [{
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  }
  packageDetails(packageId: any) {
    this.router.navigate(['packages-details'], {
      queryParams: { PackageId: packageId }
    });
  }

  onImageErrorr(event: any) {
    event.target.src = 'assets/images/safenet_logo_new.png';
  }

  defaultContactDetailsForm() {
    this.contactDetailsForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, this.customEmailValidator()]],
      countryCode: ['+1', Validators.required],
      contactNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      adults: 1,
      children: 0,
    });
    this.bookingFormSubmitted = false;
  }
  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }
  textInput(event: any, formName: string, controlName: string): void {
    const input = event.target;
    input.value = input.value.replace(/[^a-zA-Z ]/g, '');

    if (this[formName] && this[formName].patchValue) {
      this[formName].patchValue({
        [controlName]: input.value || null,
      });
    }
  }

  trimWhitespace(event: any): void {
    const input = event.target;
    input.value = input.value.replace(/\s+/g, '');
  }

  mobilenumberInput(event: any, formName: string, controlName: string): void {
    const input = event.target;

    // Allow only numeric values (0-9)
    input.value = input.value.replace(/[^0-9]/g, '');

    // Update the form control value
    this[formName].patchValue({
      [controlName]: input.value || null,
    });
  }
  openEnquiry() {
    this.contactDetailsForm.patchValue({
      name: '',
      email: '',
      countryCode: '+1',
      contactNumber: '',
      adults: 1,
      children: 0,
    })
  }
  onEnquiry() {
    this.bookingFormSubmitted = true;
    if (this.contactDetailsForm.invalid) {
      return;
    } else {
      let payload = {
        place: this.tripInfo.place || '',
        startDate: this.tripInfo.startDate || '',
        endDate: this.tripInfo.endDate || '',
        contactPerson: this.contactDetailsForm.get('name')?.value || '',
        email: this.contactDetailsForm.get('email')?.value || '',
        countryCode: this.contactDetailsForm.get('countryCode')?.value || null,
        phoneNumber: this.contactDetailsForm.get('contactNumber')?.value || '',
        adults: this.contactDetailsForm.get('adults')?.value || 0,
        children: this.contactDetailsForm.get('children')?.value || 0,
        inquiryDetails: this.generateInquiryHtml()
      }
      this.aitripDataService.sendAIPlannerInquiry(payload).subscribe(
        (response: any) => {
          if (response.code === 1) {
            this.bookingFormSubmitted = false;
            $('#enquireNow').modal('hide');

            // Cleanup fallback after hiding
            setTimeout(function () {
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
            }, 500);

            this.commonService.notifier.notify('success', "We have received your request. MyYatra360 team will reach out to you at the earliest.");
          } else {
            this.commonService.notifier.notify('error', "An Error Occured While Enquire send");
          }
        },
        (error) => {
        }
      );
    }
  }
  generateInquiryHtml(): string {
    const styles = `
    <style>
      .custom-itinerary {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        color: #333;
        background-color: #fdfdfd;
        padding: 20px;
        border-radius: 8px;
        border: 1px solid #eee;
        max-width: 700px;
        margin: 0 auto;
      }
      .custom-itinerary h1 {
        font-size: 24px;
        color: #1e2a38;
        margin-bottom: 5px;
      }
      .custom-itinerary h2 {
        font-size: 18px;
        color: #555;
        margin-bottom: 20px;
      }
      .custom-itinerary h3 {
        color: #2c3e50;
        border-bottom: 2px solid #ddd;
        padding-bottom: 8px;
        margin-bottom: 15px;
      }
      .hotel-info {
        background-color: #fafafa;
        padding: 15px;
        margin-bottom: 10px;
        border-left: 4px solid #3498db;
        border-radius: 6px;
      }
      .hotel-info h4 {
        color: #34495e;
        margin-bottom: 10px;
      }
      .hotel-info p {
        margin: 4px 0;
        font-size: 14px;
      }
      ul {
        padding-left: 20px;
        margin-top: 10px;
      }
      ul li {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 5px;
      }
      hr {
        margin: 25px 0;
        border: 0;
        border-top: 1px dashed #ccc;
      }
      .star-rating {
        color: #f39c12;
        font-size: 14px;
      }
    </style>
  `;

    let html = `${styles}<div class="custom-itinerary">`;

    // Add trip description and dates
    if (this.tripInfo) {
      html += `<h1>${this.tripInfo.description}</h1>`;
      html += `<h2>📅 ${this.tripInfo.dates}</h2>`;
    }
    this.tripItinerary.forEach((day, index) => {
      html += `<h3>Day ${index + 1}: Hotel + Activity</h3>`;

      html += `
      <div class="hotel-info">
        <h4>${day.hotels.name}</h4>
        <p><strong>Address:</strong> ${day.hotels.address}</p>
        <p><strong>Dates:</strong> ${day.hotels.dates}</p>
        <p><strong>Check-in:</strong> ${day.hotels.checkin} &nbsp;
           <strong>Check-out:</strong> ${day.hotels.checkout}</p>
        <p class="star-rating"><strong>Rating:</strong> ${'★'.repeat(day.hotels.star_rating)}</p>
      </div>
    `;

      if (day.activities?.length) {
        html += `<h5>Activities:</h5><ul>`;
        day.activities.forEach(activity => {
          html += `<li>${activity}</li>`;
        });
        html += `</ul>`;
      }

      html += `<hr/>`;
    });

    html += '</div>';
    return html;
  }
  //#endregion
}
